// ModalDeleteOrder.jsx
import Modal from "../common/Modal";

function ModalDeleteOrder({ order, onClose, onConfirm }) {
  const handleConfirm = async () => {
    const success = await onConfirm();
    if (success) {
      onClose();
    }
  };

  return (
    <Modal title="Eliminar parte" onClose={onClose}>
      <div className="input-group" style={{ textAlign: "center" }}>
        <p>
          ¿Seguro que deseas eliminar el parte?
          <br />
          <strong>CUPS:</strong> {order?.CUPS}
          <br />
          <strong>CntId:</strong> {order?.CntId}
          <br />
          Esta acción no se puede deshacer.
        </p>
      </div>
      <div
        className="input-group_row"
        style={{ justifyContent: "center", gap: "1rem" }}
      >
        <span className="boton_opciones" onClick={handleConfirm}>
          Eliminar
        </span>
        <span className="boton_cancelar" onClick={onClose}>
          Cancelar
        </span>
      </div>
    </Modal>
  );
}

export default ModalDeleteOrder;